import ReactComponent from '../../../assets/icons/export.svg?react';
import type { FC } from 'react';
import { BaseIcon, IconProps } from './BaseIcon';

export const ExportIcon: FC<IconProps> = (props) => {
    return (
        <BaseIcon {...props}>
            <ReactComponent />
        </BaseIcon>
    );
};
